import type { FC } from 'react';
import { HelpCaption } from '../capations/help-caption';
import { HelpCaptionDescription } from '../capations/help-caption-description';
import { SupportTitle } from '../capations/support-title';
import { WistiaPlayer } from '../player/wistia-player';

const PLAYER_HEIGHT = '533px';
// cspell:ignore wxf1x0mxyf 3ggmbnazu5 9ordx0jjpf
const INTRODUCTION_MEDIA_ID = 'wxf1x0mxyf';
const CREATION_MEDIA_ID = '3ggmbnazu5';
const CONSOLIDATION_MEDIA_ID = '9ordx0jjpf';

export const ShipmentHelpCenterContent: FC = () => {
  return (
    <div className="d-flex flex-direction-column">
      <SupportTitle />
      <HelpCaption>Introduction</HelpCaption>
      <HelpCaptionDescription>
        In this video, we will explore the Shipment module in detail, focusing on the user interface and its various
        functionalities. We will cover key features, such as searching shipments, managing shipping labels, and handling
        delivery schedules. Additionally, we will walk through the navigation process, highlighting how to efficiently
        access different sections of the module and utilize its tools for optimal shipment management.
      </HelpCaptionDescription>
      <WistiaPlayer mediaId={INTRODUCTION_MEDIA_ID} height={PLAYER_HEIGHT} />
      <HelpCaption>Shipment Creation</HelpCaption>
      <HelpCaptionDescription>
        This video will comprehensively explain the process of creating shipments within the Shipment module. We will
        cover each step in detail, including how to enter shipment information, select shipping options, and manage
        tracking details. By the end of this tutorial, you will have a clear understanding of how to efficiently create
        and manage shipments in our system.
      </HelpCaptionDescription>
      <WistiaPlayer mediaId={CREATION_MEDIA_ID} height={PLAYER_HEIGHT} />
      <HelpCaption>Shipment Consolidation</HelpCaption>
      <HelpCaptionDescription>
        This video will provide a comprehensive overview of the shipment consolidation feature within the Shipment
        module. We will explore how this feature allows users to combine multiple shipments into a single shipment,
        which can streamline the shipping process, reduce costs, and improve efficiency. Additionally, we will discuss
        the step-by-step procedure for utilizing this feature effectively.
      </HelpCaptionDescription>
      <WistiaPlayer mediaId={CONSOLIDATION_MEDIA_ID} height={PLAYER_HEIGHT} />
    </div>
  );
};
